import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { AppStore } from 'src/stores/AppStore/AppStore';

export const BrowserRouterBehavior = observer(() => {
    const history = useHistory();
    useEffect(() => {
        AppStore.setHistory(history);
    }, []);

    return null;
});
